module.exports = __webpack_public_path__ + "img/shopify.d540363c.png";